// test1828
(1828 && 0);
